import { useEffect } from "react";
import { useDispatch } from "react-redux";
import UploadHeader from "components/upload/UploadHeader";
import UploadSteps from "components/upload/UploadSteps/UploadSteps";
import { NotAuthorizedPopup } from "components/popups";
import { fetchNiches } from "store/niches/niches-action";
import { fetchTags } from "store/tags/tags-action";
import { useIsAuth } from "hooks";
import "./UploadPage.scss";

export const UploadPage = () => {
  const isAuth = useIsAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTags());
    dispatch(fetchNiches());
    // eslint-disable-next-line
  }, [])

  document.title = "Uploader | RedGIFs";

  return (
    <div className="UploadPage">
      <UploadHeader
        title="Upload"
      />
      { isAuth ? <UploadSteps/> : <NotAuthorizedPopup /> }
    </div>
  );
};
